import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7edecd0a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BodyHomeBannerContent: require('/home/luiz/Sistemas/loja/components/BodyHome/BannerContent.vue').default,AlertaUrgentes: require('/home/luiz/Sistemas/loja/components/AlertaUrgentes.vue').default,BodyHomeBannerCardValues: require('/home/luiz/Sistemas/loja/components/BodyHome/BannerCardValues.vue').default,BodyHomeSlideBanner: require('/home/luiz/Sistemas/loja/components/BodyHome/SlideBanner.vue').default,BodyHomeBannerSDC: require('/home/luiz/Sistemas/loja/components/BodyHome/BannerSDC.vue').default,BodyHomeBannerIssuanceModality: require('/home/luiz/Sistemas/loja/components/BodyHome/BannerIssuanceModality.vue').default,BodyHomeBannerOurSolutions: require('/home/luiz/Sistemas/loja/components/BodyHome/BannerOurSolutions.vue').default,BodyHomeNewsComponent: require('/home/luiz/Sistemas/loja/components/BodyHome/NewsComponent.vue').default})
